import { isPlatformBrowser, NgForOf, NgIf } from '@angular/common';
import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, Inject, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { FollowedUsersPost } from 'src/app/services/http-services/home/home-interfaces';
import { HomeService } from 'src/app/services/http-services/home/home.service';
import { HeaderModule } from 'src/app/shared-components/header/header.module';
import { MyContentModule } from 'src/app/shared-components/my-content/my-content.module';
import { LatestPostComponent } from './components/latest-post/latest-post.component';
import { ListComponent } from './components/list/list.component';
import { ListerComponent } from './components/lister/lister.component';
import { ThemeComponent } from './components/theme/theme.component';
import { ShareEntitiesEnums } from 'src/app/enums/chat-enums';
import { UserRoles } from 'src/app/enums/general-enums';
import { ReportModalComponent } from 'src/app/shared-components/report-modal/report-modal.component';
import { SharingOptionsModalComponent } from '../my-profile/components/sharing-options-modal/sharing-options-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { PostsHttpService } from 'src/app/services/http-services/posts/posts-http.service';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'tl-home',
  templateUrl: './home.component.html',
  standalone: true,
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
  imports: [
    RouterModule,
    NgForOf,
    NgIf,
    MyContentModule,
    HeaderModule,
    ListComponent,
    ListerComponent,
    ThemeComponent,
    LatestPostComponent,
    ReportModalComponent,
    SharingOptionsModalComponent,
    TranslateModule
  ]
})
export class HomeComponent implements OnInit {
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  homepageData: any;
  selectedPost: any;
  isReportPostModalOpen = false;
  isSharePostModalOpen = false;
  baseUrl = '';
  postUrl = '';
  protected readonly UserRoles = UserRoles;
  protected readonly ShareEntitiesEnums = ShareEntitiesEnums;

  constructor(
    private homeHttp: HomeService,
    @Inject(PLATFORM_ID) private platformId: string,
    private postsHttpService: PostsHttpService,
    private meta: Meta,
  ){}

  ngOnInit(): void {
    this.getHomepageData();
    if (isPlatformBrowser(this.platformId)) {
      this.baseUrl = window.location.origin;
    }
  }

  getHomepageData(): void {
    this.homeHttp.formattedGetHomepageData().then((res: any) => {
      this.homepageData = res.data;
    });
  }

  getSelectedPost(post: FollowedUsersPost): void {
    this.getPublicSinglePostData(post.id);
    this.selectedPost = post;
    this.postUrl = this.baseUrl + PAGES_AND_PATHS.singlePost.pagePath + '/' + this.selectedPost.id;
  }

  openReport(event: any): void {
    this.isReportPostModalOpen = event;
  }

  getPublicSinglePostData(postId: number): void {
    this.postsHttpService.getPublicSinglePost({ postId: postId }).then(res => {
      const publicPostData = res.data;
      let ogImage;
      if (publicPostData.lyst && publicPostData.lyst.lyst_image_url !== null) {
        ogImage = publicPostData.lyst.lyst_image_url;
      } else if (publicPostData.lyst_item && publicPostData.lyst_item.lyst_item_image_url !== null) {
        ogImage = publicPostData.lyst_item.lyst_item_image_url;
      } else {
        ogImage = 'assets/images/og-image.png';
      }
      this.meta.updateTag({
        property: 'og:title',
        content: `${publicPostData.user.username} on TheLysts: ${publicPostData.content.slice(0, 20)}...`
      });
      this.meta.updateTag({
        property: 'og:description',
        content: `${publicPostData.user.username} on TheLysts: ${publicPostData.content.slice(0, 20)}...`
      });
      this.meta.updateTag({
        property: 'og:image',
        content: ogImage
      });
      this.meta.updateTag({
        property: 'og:url', content: this.postUrl
      });
    });
  }

}
